import { render, staticRenderFns } from "./DashBoard.vue?vue&type=template&id=33adef7c&scoped=true"
import script from "./DashBoard.vue?vue&type=script&lang=js"
export * from "./DashBoard.vue?vue&type=script&lang=js"
import style0 from "./DashBoard.vue?vue&type=style&index=0&id=33adef7c&prod&scoped=true&lang=css"
import style1 from "./DashBoard.vue?vue&type=style&index=1&id=33adef7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33adef7c",
  null
  
)

export default component.exports